import {isFunction} from 'lodash'
import {ApiConnection} from './apiConnection'

export type ApiRequestCreator = (connection: ApiConnection) => any
export interface ApiRequestCreators {[key: string]: (connection: ApiConnection) => any}
export type ApiRequestCall<T extends ApiRequestCreator> = ReturnType<T>
export type ApiRequestCalls<T extends ApiRequestCreators> = {[key in keyof T]: ReturnType<T[key]>}

export function bindApiCreator<T extends ApiRequestCreator>(
  apiRequestCreator: T, connection: ApiConnection
): ApiRequestCall<T> {
  return apiRequestCreator(connection)
}

export function bindApiCreators<T extends ApiRequestCreators>(
  apiRequestCreators: T, connection: ApiConnection
): ApiRequestCalls<T> {
  return Object.keys(apiRequestCreators)
    .reduce((result, key) => {
      const apiRequestCreator = apiRequestCreators[key]
      if (!isFunction(apiRequestCreator)) {
        return result
      }
      return {
        ...result,
        [key]: bindApiCreator(apiRequestCreator, connection)
      }
    }, {}) as ApiRequestCalls<T>
}

interface SortingParams {
  field: string
  order?: 'asc' | 'desc'
}

export interface ISortingOption {
  [key: string]: SortingParams[]
}

export const stringifySortingOptions = (sortingOptions?: ISortingOption) => {
  const stringifyParams = (params: SortingParams[]) => (
    params.reduce((acc, item, index, arr) => {
      return `${acc}${item.order === 'desc' ? '-' : ''}${item.field}${(index) !== (arr.length - 1) ? ',' : '' }`
    }, '')
  )

  if (sortingOptions) {
    return Object.keys(sortingOptions).reduce((acc, item, index, arr) => {
      return `${acc}${item}=${stringifyParams(sortingOptions[item])}`
    }, '')
  }
  return ''
}
